import { QuickFeedbackStyleOption, StyleOption } from './types';
import bwSmileBad from 'src/assets/images/csat-config-pics/bw-smile-bad.svg';
import bwSmileExcellent from 'src/assets/images/csat-config-pics/bw-smile-excellent.svg';
import bwSmileGood from 'src/assets/images/csat-config-pics/bw-smile-good.svg';
import bwSmileOkay from 'src/assets/images/csat-config-pics/bw-smile-okay.svg';
import bwSmileTerrible from 'src/assets/images/csat-config-pics/bw-smile-terrible.svg';
import emptyStar from 'src/assets/images/csat-config-pics/empty-star.svg';
import smileBad from 'src/assets/images/csat-config-pics/smile-bad.svg';
import smileExcellent from 'src/assets/images/csat-config-pics/smile-excellent.svg';
import smileGood from 'src/assets/images/csat-config-pics/smile-good.svg';
import smileOkay from 'src/assets/images/csat-config-pics/smile-okay.svg';
import smileTerrible from 'src/assets/images/csat-config-pics/smile-terrible.svg';
import star from 'src/assets/images/csat-config-pics/star.svg';
import thumbDown from 'src/assets/images/csat-config-pics/thumb-down.svg';
import thumbUp from 'src/assets/images/csat-config-pics/thumb-up.svg';
import quickFeedbackBwSmileExcellent from 'src/assets/images/quick-feedback-config-pics/bw-smile-excellent.svg';
import quickFeedbackBwSmileExcellentActive from 'src/assets/images/quick-feedback-config-pics/bw-smile-excellent-active.svg';
import quickFeedbackBwSmileTerrible from 'src/assets/images/quick-feedback-config-pics/bw-smile-terrible.svg';
import quickFeedbackBwSmileTerribleActive from 'src/assets/images/quick-feedback-config-pics/bw-smile-terrible-active.svg';
import quickFeedbackHeartExcellent from 'src/assets/images/quick-feedback-config-pics/heart-excellent.svg';
import quickFeedbackHeartExcellentActive from 'src/assets/images/quick-feedback-config-pics/heart-excellent-active.svg';
import quickFeedbackHeartTerrible from 'src/assets/images/quick-feedback-config-pics/heart-terrible.svg';
import quickFeedbackHeartTerribleActive from 'src/assets/images/quick-feedback-config-pics/heart-terrible-active.svg';
import quickFeedbackThumbDown from 'src/assets/images/quick-feedback-config-pics/thumb-down.svg';
import quickFeedbackThumbDownActive from 'src/assets/images/quick-feedback-config-pics/thumb-down-active.svg';
import quickFeedbackThumbUp from 'src/assets/images/quick-feedback-config-pics/thumb-up.svg';
import quickFeedbackThumbUpActive from 'src/assets/images/quick-feedback-config-pics/thumb-up-active.svg';

export const csatOneToFiveOptions: StyleOption[] = [
  {
    icon: star,
    icons: [emptyStar, emptyStar, emptyStar, emptyStar, emptyStar],
    label: 'Stars',
    selectedIcon: star,
    value: 'star',
  },
  {
    icon: smileExcellent,
    icons: [smileTerrible, smileBad, smileOkay, smileGood, smileExcellent],
    label: 'Smiles',
    value: 'smile',
  },
  {
    icon: bwSmileExcellent,
    icons: [
      bwSmileTerrible,
      bwSmileBad,
      bwSmileOkay,
      bwSmileGood,
      bwSmileExcellent,
    ],
    label: 'BW smiles',
    value: 'bw_smile',
  },
];

export const csatOneToTwoOptions: StyleOption[] = [
  {
    icon: thumbUp,
    icons: [thumbUp, thumbDown],
    label: 'Thumbs',
    value: 'thumbs',
  },
];

export const quickFeedbackOneToTwoOptions: QuickFeedbackStyleOption[] = [
  {
    label: 'Thumbs',
    negativeIcons: {
      active: quickFeedbackThumbDownActive,
      default: quickFeedbackThumbDown,
    },
    positiveIcons: {
      active: quickFeedbackThumbUpActive,
      default: quickFeedbackThumbUp,
    },
    value: 'thumbs',
  },
  {
    label: 'BW Smiles',
    negativeIcons: {
      active: quickFeedbackBwSmileTerribleActive,
      default: quickFeedbackBwSmileTerrible,
    },
    positiveIcons: {
      active: quickFeedbackBwSmileExcellentActive,
      default: quickFeedbackBwSmileExcellent,
    },
    value: 'bw_smile',
  },
  {
    label: 'Hearts',
    negativeIcons: {
      active: quickFeedbackHeartTerribleActive,
      default: quickFeedbackHeartTerrible,
    },
    positiveIcons: {
      active: quickFeedbackHeartExcellentActive,
      default: quickFeedbackHeartExcellent,
    },
    value: 'hearts',
  },
];
